"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringDiff = exports.distinctByKey = exports.dedupe = exports.overlapBetween = exports.splitNWays = exports.max = exports.all = exports.any = exports.min = exports.first = exports.last = exports.orderByStrDescending = exports.orderByStrAscending = exports.orderByDescending = exports.orderByAscending = exports.groupByArr = exports.groupBy = exports.contains = exports.aggCount = exports.aggregate = exports.range = exports.selectMany = exports.intersection = exports.betweenIncl = exports.distinct = exports.flatten = exports.iter = exports.sum = exports.reverse = void 0;
function reverse(list) {
    var newList = [];
    for (var i = list.length - 1; i >= 0; i--) {
        newList.push(list[i]);
    }
    return newList;
}
exports.reverse = reverse;
function sum(list) {
    return list.reduce(function (acc, v) { return acc + v; }, 0);
}
exports.sum = sum;
function iter(iterable) {
    var list = [];
    for (var i = 0; i < iterable.length; i++) {
        list.push(iterable[i]);
    }
    return list;
}
exports.iter = iter;
function flatten(input) {
    return input.reduce(function (list, item) {
        return __spreadArray(__spreadArray([], list, true), item, true);
    }, []);
}
exports.flatten = flatten;
function distinct(input, selector) {
    if (!selector)
        selector = function (v) { return v; };
    return input.map(selector).filter(function (value, index, array) { return array.indexOf(value) === index; });
}
exports.distinct = distinct;
function betweenIncl(test, boundA, boundB) {
    var min = Math.min(boundA, boundB);
    var max = Math.max(boundA, boundB);
    return test >= min && test <= max;
}
exports.betweenIncl = betweenIncl;
function intersection(a, b) {
    return a.filter(function (el) { return b.indexOf(el) !== -1; });
}
exports.intersection = intersection;
function selectMany(input, selector) {
    return flatten(input.map(selector));
}
exports.selectMany = selectMany;
function range(a, b) {
    if (b === void 0) { b = null; }
    var start = a;
    var end;
    if (b === null) {
        start = 0;
        end = a;
    }
    else {
        end = b;
    }
    var out = [];
    for (var i = start; i < end; i++) {
        out.push(i);
    }
    return out;
}
exports.range = range;
function aggregate(list, keySelector, aggregate) {
    return list.reduce(function (acc, value) {
        var key = keySelector(value);
        var oldValue = acc[key] || 0;
        acc[key] = aggregate(value, oldValue);
        return acc;
    }, {});
}
exports.aggregate = aggregate;
function aggCount(list, keySelector) {
    return aggregate(list, keySelector, function (current, acc) { return 1 + acc; });
}
exports.aggCount = aggCount;
function contains(arr, search) {
    return arr.indexOf(search) !== -1;
}
exports.contains = contains;
function groupBy(list, keySelector) {
    return list.reduce(function (accumulator, value) {
        var _a;
        var _b;
        var key = keySelector(value);
        var arr = (_b = accumulator[key]) !== null && _b !== void 0 ? _b : [];
        return Object.assign(accumulator, (_a = {},
            _a[key] = __spreadArray(__spreadArray([], arr, true), [value], false),
            _a));
    }, {});
}
exports.groupBy = groupBy;
function groupByArr(list, keySelector, compareKeyByReference) {
    if (compareKeyByReference === void 0) { compareKeyByReference = false; }
    var keys = [];
    return list.reduce(function (accumulator, value) {
        var keyValue = keySelector(value);
        var lookupKey = keyValue;
        if (!compareKeyByReference)
            lookupKey = JSON.stringify(keyValue);
        var index = keys.indexOf(lookupKey);
        if (index === -1) {
            accumulator.push({ key: keyValue, values: [value] });
            keys.push(lookupKey);
            return accumulator;
        }
        accumulator[index].values.push(value);
        return accumulator;
    }, []);
}
exports.groupByArr = groupByArr;
function orderByAscending(list, selector) {
    list.sort(function (a, b) { return selector(a) - selector(b); });
}
exports.orderByAscending = orderByAscending;
function orderByDescending(list, selector) {
    list.sort(function (a, b) { return selector(b) - selector(a); });
}
exports.orderByDescending = orderByDescending;
function orderByStrAscending(list, selector) {
    list.sort(function (a, b) {
        var aVal = selector(a);
        var bVal = selector(b);
        if (aVal < bVal)
            return -1;
        if (aVal > bVal)
            return 1;
        return 0;
    });
}
exports.orderByStrAscending = orderByStrAscending;
function orderByStrDescending(list, selector) {
    list.sort(function (a, b) {
        var aVal = selector(a);
        var bVal = selector(b);
        if (aVal < bVal)
            return 1;
        if (aVal > bVal)
            return -1;
        return 0;
    });
}
exports.orderByStrDescending = orderByStrDescending;
function last(items, selector) {
    for (var i = items.length - 1; i >= 0; i--) {
        if (selector(items[i]))
            return items[i];
    }
    return null;
}
exports.last = last;
function first(items, selector) {
    for (var i = 0; i < items.length; i++) {
        if (selector(items[i]))
            return items[i];
    }
    return null;
}
exports.first = first;
function min(items, selector) {
    if (items.length === 0)
        throw new Error('no items in list');
    var minIndex = 0;
    var minValue = Infinity;
    items
        .map(function (item) { return selector(item); })
        .map(function (value, i) {
        if (value < minValue) {
            minIndex = i;
            minValue = value;
        }
        return null;
    });
    return items[minIndex];
}
exports.min = min;
function any(items, selector) {
    for (var i = 0; i < items.length; i++) {
        if (selector(items[i]))
            return true;
    }
    return false;
}
exports.any = any;
function all(items, selector) {
    return items.filter(selector).length === items.length;
}
exports.all = all;
function max(items, selector) {
    if (items.length === 0)
        throw new Error('no items in list');
    var maxIndex = 0;
    var maxValue = -Infinity;
    items
        .map(function (item) { return selector(item); })
        .map(function (value, i) {
        if (value > maxValue) {
            maxIndex = i;
            maxValue = value;
        }
        return null;
    });
    return items[maxIndex];
}
exports.max = max;
function splitNWays(elements, n) {
    if (elements.length < n) {
        throw new Error("can't split a list of " + elements.length + ' elements ' + n + ' ways');
    }
    var position = 0;
    return range(n).map(function (index) {
        var howMany = Math.floor((elements.length - position) / (n - index));
        var result = elements.slice(position, position + howMany);
        position = position + howMany;
        return result;
    });
}
exports.splitNWays = splitNWays;
function overlapBetween(a, b) {
    return a.filter(function (v) { return contains(b, v); });
}
exports.overlapBetween = overlapBetween;
function dedupe(list) {
    return list.filter(function (item, index) {
        for (var i = index + 1; i < list.length; i++) {
            if (list[i] === item)
                return false;
        }
        return true;
    });
}
exports.dedupe = dedupe;
function distinctByKey(value, keySelector) {
    var keys = [];
    var out = [];
    for (var _i = 0, value_1 = value; _i < value_1.length; _i++) {
        var v = value_1[_i];
        var key = keySelector(v);
        if (keys.indexOf(key) !== -1)
            continue;
        keys.push(key);
        out.push(v);
    }
    return out;
}
exports.distinctByKey = distinctByKey;
function stringDiff(a, b) {
    if (a === b)
        return 0;
    if (a > b)
        return -1;
    return 1;
}
exports.stringDiff = stringDiff;
